// extracted by mini-css-extract-plugin
export default {"wrapper":"IpD03","iOS":"ozKEH"};